import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render() {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95426 31.0457 0 20 0C8.95426 0 0 8.95426 0 20C0 31.0457 8.95426 40 20 40ZM21.9445 11.6667H18.3333L18.75 22.0833H21.5278L21.9445 11.6667ZM20.1387 27.6388C21.0974 27.6388 21.8747 26.8616 21.8747 25.9029C21.8747 24.9438 21.0974 24.1667 20.1387 24.1667C19.1798 24.1667 18.4025 24.9438 18.4025 25.9029C18.4025 26.8616 19.1798 27.6388 20.1387 27.6388Z",
          "clip-rule": "evenodd",
        }),
      ],
    )
  );
}
